/// <reference path='../_all.ts' />


module supportportal {
   /**
    * Angular Service http://stackoverflow.com/questions/19447886/how-can-i-define-an-angularjs-service-using-a-typescript-class-that-doesnt-poll
    */
   export class SupportPortalService implements ISupportPortalService {
      static $inject = [
         '$http',
         'CacheFactory',
         'userService',
      ];

      constructor(
         // Add the parameter and type definition.
         public $http: ng.IHttpService,
         private CacheFactory: CacheFactory.ICacheFactory,
         private userService: user.UserService
      ) { }

      public getMacAddresses(serial: string): ng.IHttpPromise<void> {
         const query = `{
                            ethernetAddress(serial: "${serial}") {
                              offset
                              serial
                              utcUpdated
                              utcReserved
                              ethernetAddress
                            }
                          }`;

         var tokenPromise = this.userService.getJwtToken();
         return tokenPromise.then((token: string): ng.IHttpPromise<void> => {

            return this.$http<boolean>({
               method: "POST"
               , url: pglob.RouteData.PhotometerApiBaseUrl + "/graphql"
               , headers: this.userService.getBearer(token)
               , params: {
               }
               , data: {
                  "query": query
                  , "variables": {}
               }
            }).then((response: { data: any }): any => { //success
               return response;
            })
               .catch((response) => {
                  throw "Error in 'SupportPortalService.getMacAddresses' " + response.status;
               });
         });
      }
      
      public certsBySerials(serials: string[]): ng.IHttpPromise<api_photometer.GraphQlResponse<api_photometer.documentsByMultipleSerials_Return>> {
         const query = `query getDocumentsBySerials($serials: [String!]!) {
                            documentsByMultipleSerials(serials: $serials) {
                            serialnumber
                                documents {
                                    id
                                    type
                                }
                            }
                        }`;

         var tokenPromise = this.userService.getJwtToken();
         return tokenPromise.then((token: string): ng.IHttpPromise<api_photometer.GraphQlResponse<api_photometer.documentsByMultipleSerials_Return>> => {
            var p = this.$http<boolean>({
                                       method: "POST"
                                       , url: pglob.RouteData.PhotometerApiBaseUrl + "/graphql"
                                       , headers: this.userService.getBearer(token)
                                       , params: {
                                       }
                                       , data: {
                                          "query": query
                                          , "variables": {
                                              "serials": serials
                                          }
                                       }
                                    }).then((response: { data: any }): any => {
                                       if (response.data.errors && response.data.errors.length > 0) {
                                          throw response.data.errors;
                                       }
                                       return response;
                                    }).catch((response) => {
                                          throw response;
                                    });
            return p;
         });

      }

      

      public itemsBySerial(serial: string): ng.IHttpPromise<api_photometer.GraphQlResponse<api_photometer.itemBySerialWithSub_Return>> {
         const query = `query GetItemBySerialWithSub($serial: String!) {
                          itemBySerialWithSub(serial: $serial) {
                            serialnumber
                            itemId
                            productId 
                            parentSerialnumber 
                          }
                        }`;

         var tokenPromise = this.userService.getJwtToken();
         return tokenPromise.then((token: string): ng.IHttpPromise<api_photometer.GraphQlResponse<api_photometer.itemBySerialWithSub_Return>> => {
            var p = this.$http<boolean>({
                                       method: "POST"
                                       , url: pglob.RouteData.PhotometerApiBaseUrl + "/graphql"
                                       , headers: this.userService.getBearer(token)
                                       , params: {
                                       }
                                       , data: {
                                          "query": query
                                          , "variables": {
                                              "serial": serial
                                          }
                                       }
                                    }).then((response: { data: any }): any => {
                                       if (response.data.errors && response.data.errors.length > 0) {
                                          throw response.data.errors;
                                       }
                                       return response;
                                    }).catch((response) => {
                                          throw response;
                                    });
            return p;
         });

      }

      



   }

}
